import { api } from './client';
export async function getMyCards() {
    return api('/api/cards/my');
}
export async function getUserCards(userId) {
    return api(`/api/cards/user/${userId}`);
}
export async function createCard(data) {
    return api('/api/cards', {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
